// Copyright (c) 2017 Deere & Company

import PipProducts from '../../shared/state/pip-products';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

export const updatePipProductsFiltered = (state, action) =>
    PipProducts.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().pipProductsFiltered, action) => {

    const actionTypes = {
        [actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED]: updatePipProductsFiltered
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/pip-products-filtered.js